/**
 * MODULE: _shared/frontend-shell/src/design-system/components/AiAssistant/applyAssistantHljsTheme.ts
 * PURPOSE: Inject one global `<style id="brazn-ai-assistant-hljs">` so highlight.js tokens match light vs dark UI.
 */

import githubDark from 'highlight.js/styles/github-dark.css?raw';
import githubLight from 'highlight.js/styles/github.css?raw';

const STYLE_ID = 'brazn-ai-assistant-hljs';

/** Apply GitHub vs GitHub-dark hljs rules (sync; both bundled at build time). */
export function applyAssistantHljsTheme(isDark: boolean): void {
  const el =
    (document.getElementById(STYLE_ID) as HTMLStyleElement | null) ??
    (() => {
      const s = document.createElement('style');
      s.id = STYLE_ID;
      document.head.appendChild(s);
      return s;
    })();

  el.textContent = isDark ? githubDark : githubLight;
}
